import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = { class: "text-center ma-0" }
const _hoisted_5 = { class: "px-4" }
const _hoisted_6 = { class: "pl-4" }
const _hoisted_7 = { class: "pl-4" }
const _hoisted_8 = { class: "px-4" }
const _hoisted_9 = {
  key: 0,
  class: "text-primary px-4 pb-4"
}
const _hoisted_10 = { style: {"font-weight":"bold","border-right":"1px solid #dddddd"} }
const _hoisted_11 = {
  key: 0,
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"},
  class: "text-right"
}
const _hoisted_12 = {
  key: 1,
  class: "text-right pr-8",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_13 = {
  key: 2,
  class: "text-right pr-8"
}
const _hoisted_14 = {
  key: 3,
  class: "text-right pr-8"
}
const _hoisted_15 = {
  key: 4,
  class: "text-right"
}
const _hoisted_16 = {
  key: 5,
  class: "text-right pr-8"
}
const _hoisted_17 = {
  key: 6,
  class: "text-right"
}
const _hoisted_18 = {
  key: 7,
  class: "text-right pr-8"
}
const _hoisted_19 = {
  key: 8,
  class: "text-right"
}
const _hoisted_20 = {
  key: 9,
  class: "text-right pr-8"
}
const _hoisted_21 = {
  key: 10,
  class: "text-right"
}
const _hoisted_22 = {
  key: 11,
  class: "text-right pr-8"
}
const _hoisted_23 = {
  key: 12,
  class: "text-right"
}
const _hoisted_24 = {
  key: 13,
  class: "text-right pr-8"
}
const _hoisted_25 = {
  key: 14,
  class: "text-right",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_26 = {
  key: 15,
  class: "text-right pr-8",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_27 = { style: {"font-weight":"bold","border-right":"1px solid #dddddd"} }
const _hoisted_28 = { style: {"text-align":"right","border-right":"1px solid #dddddd"} }
const _hoisted_29 = { class: "pr-8" }
const _hoisted_30 = { style: {"text-align":"right"} }
const _hoisted_31 = { class: "pr-8" }
const _hoisted_32 = { style: {"text-align":"right"} }
const _hoisted_33 = { class: "pr-8" }
const _hoisted_34 = { style: {"text-align":"right"} }
const _hoisted_35 = { class: "pr-8" }
const _hoisted_36 = { style: {"text-align":"right"} }
const _hoisted_37 = { class: "pr-8" }
const _hoisted_38 = { style: {"text-align":"right"} }
const _hoisted_39 = { class: "pr-8" }
const _hoisted_40 = { style: {"text-align":"right"} }
const _hoisted_41 = { class: "pr-8" }
const _hoisted_42 = { style: {"text-align":"right"} }
const _hoisted_43 = {
  key: 0,
  class: "text-left"
}
const _hoisted_44 = {
  key: 1,
  class: "text-center"
}
const _hoisted_45 = {
  key: 2,
  class: "text-center"
}
const _hoisted_46 = {
  key: 3,
  class: "text-center"
}
const _hoisted_47 = { class: "text-left" }
const _hoisted_48 = { class: "text-left" }
const _hoisted_49 = { class: "text-right" }
const _hoisted_50 = { class: "text-right" }
const _hoisted_51 = { class: "text-right" }
const _hoisted_52 = {
  key: 4,
  class: "text-center"
}
const _hoisted_53 = {
  key: 5,
  class: "text-center"
}
const _hoisted_54 = { class: "text-center pl-2 py-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_AuditDeleteAuditCheckResultDialog = _resolveComponent("AuditDeleteAuditCheckResultDialog")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.mode != 'Embedded')
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "d-flex justify-space-between mb-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex flex-column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "1",
                        class: "d-flex align-center justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_back, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "11",
                        class: "d-flex align-center"
                      }, {
                        default: _withCtx(() => [
                          _cache[52] || (_cache[52] = _createElementVNode("h2", null, "Balance âgée - Créances échues par date", -1)),
                          _createVNode(_component_v_tooltip, { location: "bottom" }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn_icon, _mergeProps(props, {
                                size: "large",
                                class: "ml-2",
                                icon: "$oss-help"
                              }), null, 16)
                            ]),
                            default: _withCtx(() => [
                              _cache[42] || (_cache[42] = _createElementVNode("h2", { class: "pt-2 pb-1" }, "Ce contrôle permets de nettoyer les comptes", -1)),
                              _cache[43] || (_cache[43] = _createElementVNode("h2", { class: "pb-2" }, " et, seulement ensuite, d'afficher la balance âgée. ", -1)),
                              _cache[44] || (_cache[44] = _createElementVNode("h4", { class: "mb-0" }, " Les documents et paiements en attente de validation ou de lettrage ", -1)),
                              _cache[45] || (_cache[45] = _createElementVNode("h4", { class: "mb-0" }, "ne sont pas pris en compte.", -1)),
                              _cache[46] || (_cache[46] = _createElementVNode("h2", { class: "py-2" }, "Procéder dans l'ordre :", -1)),
                              _cache[47] || (_cache[47] = _createElementVNode("p", { class: "mb-0" }, "Dans \"Documents\" :", -1)),
                              _cache[48] || (_cache[48] = _createElementVNode("p", { class: "mb-1" }, " - les filtres \"A vérifier\" et \"A vérifier et OK\" doivent être vides ", -1)),
                              _cache[49] || (_cache[49] = _createElementVNode("p", { class: "mb-0" }, "Dans ce contrôle :", -1)),
                              _cache[50] || (_cache[50] = _createElementVNode("p", { class: "mb-0" }, " - nettoyer le compte 471 (les soldes doivent être nuls) ", -1)),
                              _cache[51] || (_cache[51] = _createElementVNode("p", { class: "mb-0" }, " - lettrer les comptes 411 (y compris les lettrages partiels) ", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "1" }),
                      _createVNode(_component_v_col, { cols: "10" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "d-flex justify-end align-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tooltip, {
                        location: "bottom",
                        text: "Lier un document"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                          }, props, {
                            size: "x-small",
                            icon: "$oss-upload",
                            class: "mx-1"
                          }), null, 16)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, {
                        location: "bottom",
                        text: "Message"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                          }, props, {
                            size: "x-small",
                            icon: "$oss-chat",
                            class: "mx-1"
                          }), null, 16)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createAdjustmentsData())),
                        size: "small",
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => _cache[53] || (_cache[53] = [
                          _createTextVNode(" Enregistrer ")
                        ])),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        disabled: _ctx.closedPeriod || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                        "data-cy": "CheckReceivablesAgeing-valid",
                        size: "small",
                        class: "mx-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      (_ctx.isEnableReview)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[54] || (_cache[54] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                            _createVNode(_component_v_icon, {
                              disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                              size: "small",
                              icon: "$fa-thumbs-up",
                              color: "primary",
                              class: "mx-1",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.createAdjustmentsData('REVIEW');
                            })
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_v_icon, {
                              disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                              size: "small",
                              icon: "$fa-thumbs-down",
                              color: "primary",
                              class: "mx-1",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.createAdjustmentsData('REVIEW');
                            })
                            }, null, 8, ["disabled"]),
                            _cache[55] || (_cache[55] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_prev, _mergeProps(props, {
                            disabled: !_ctx.previousControl,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                          }), null, 16, ["disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_next, _mergeProps(props, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                            disabled: !_ctx.nextControl
                          }), null, 16, ["disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                        ]),
                        _: 1
                      }),
                      _cache[62] || (_cache[62] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                            class: "mx-1",
                            color: "secondary"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, { nav: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                                      _createTextVNode("$oss-activity")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[56] || (_cache[56] = [
                                      _createTextVNode("Afficher l'activité")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (!_ctx.showDeleteAcrBtnIfRecovery)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    location: "bottom"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ "no-gutters": "" }, props), [
                                        _createVNode(_component_v_list_item, {
                                          "no-gutters": "",
                                          disabled: ""
                                        }, {
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_icon, { size: "small" }, {
                                              default: _withCtx(() => _cache[59] || (_cache[59] = [
                                                _createTextVNode(" $oss-trash ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[58] || (_cache[58] = [
                                                _createTextVNode(" Supprimer le contrôle ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ], 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.showDeleteAcrBtnTooltipMessage), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 1,
                                    "no-gutters": "",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteAuditCheckResultDialog = true))
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[61] || (_cache[61] = [
                                          _createTextVNode("$oss-trash")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => _cache[60] || (_cache[60] = [
                                          _createTextVNode(" Supprimer le contrôle ")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[63] || (_cache[63] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[64] || (_cache[64] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.closedPeriod)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2 mb-1",
                          size: "large"
                        }, {
                          default: _withCtx(() => _cache[65] || (_cache[65] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[66] || (_cache[66] = _createElementVNode("h3", null, "Période clôturée", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.globalAmounts || !_ctx.globalAmounts.grossAmountSigned)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => _cache[67] || (_cache[67] = [
                            _createElementVNode("h3", null, "Aucune régularisation enregistrée ou non lettrée", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.mode != 'Embedded')
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                      key: 2,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "d-flex justify-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => [
                                    _cache[72] || (_cache[72] = _createElementVNode("h5", { class: "pl-4" }, "Grand livre c/471 (paiements non affectés) :", -1)),
                                    _createElementVNode("div", _hoisted_4, [
                                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_icon, _mergeProps({ color: "primary" }, props, { class: "ml-2" }), {
                                            default: _withCtx(() => _cache[68] || (_cache[68] = [
                                              _createTextVNode(" $oss-help ")
                                            ])),
                                            _: 2
                                          }, 1040)
                                        ]),
                                        default: _withCtx(() => [
                                          _cache[69] || (_cache[69] = _createElementVNode("h3", { class: "py-2" }, "Compte 471 :", -1)),
                                          _cache[70] || (_cache[70] = _createElementVNode("p", { class: "py-0 my-0" }, " - affecter toutes les écritures de type \"Banque\" ", -1)),
                                          _cache[71] || (_cache[71] = _createElementVNode("p", { class: "py-0 mt-0" }, " - ensuite, vérifier que le solde soit nul ", -1))
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "d-flex align-center px-4",
                                      "no-gutters": "",
                                      style: _normalizeStyle(_ctx.colorStyle(_ctx.totalBalance471NL, 'red'))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "auto",
                                          class: "d-flex justify-start"
                                        }, {
                                          default: _withCtx(() => _cache[73] || (_cache[73] = [
                                            _createElementVNode("h5", null, "Solde N :", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_col, {
                                          cols: "auto",
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("h5", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.totalBalance471NL,
                                                    undefined,
                                                )), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["style"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "d-flex align-center px-4",
                                      "no-gutters": "",
                                      style: _normalizeStyle(_ctx.colorStyle(_ctx.totalBalance411NLNextPeriod, 'red'))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "auto",
                                          class: "d-flex justify-start"
                                        }, {
                                          default: _withCtx(() => _cache[74] || (_cache[74] = [
                                            _createElementVNode("h5", null, "Solde N+1 :", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_col, {
                                          cols: "auto",
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("h5", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.totalBalance471NLNextPeriod,
                                                    undefined,
                                                )), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["style"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "1" }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                            _ctx.generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.generalLedgerExpand = !_ctx.generalLedgerExpand)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period, y) => {
                              return (_openBlock(), _createBlock(_component_v_card, {
                                key: y,
                                style: {"background-color":"white","border-radius":"25px","padding":"10px"},
                                class: "pa-2 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_subtitle, { class: "ma-0 pa-0" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", _hoisted_5, "Grand livre " + _toDisplayString(period.period), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger471 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_GeneralLedger, {
                                                companyId: _ctx.companyId,
                                                accountingPeriodId: period.id,
                                                accountableAccountFilter: ['471'],
                                                inNm1: false,
                                                hideOptions: true,
                                                withoutLetteringIfHidedOptions: true,
                                                hideBodyAppend: true,
                                                onQueryDone: period.onQueryDone2,
                                                enableAuditedAccountableAccounts: true
                                              }, null, 8, ["companyId", "accountingPeriodId", "onQueryDone"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.generalLedgerExpand]
                        ])
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, _ctx.show471NL || _ctx.show471NLNextPeriod]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.mode != 'Embedded')
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                      key: 3,
                      class: "audit-card"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          style: _normalizeStyle(_ctx.colorStyle(_ctx.totalBalance411NL, 'red'))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "ma-0 d-flex justify-start align-center py-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "d-flex align-center ma-0 pa-0" }, {
                                  default: _withCtx(() => [
                                    _cache[77] || (_cache[77] = _createElementVNode("h5", { class: "pl-4 ma-0" }, " Grand livre c/411 (lettrages à compléter, mouvements à venir en N+1) : ", -1)),
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps({ color: "red" }, props, {
                                          class: "ml-2",
                                          size: "small"
                                        }), {
                                          default: _withCtx(() => _cache[75] || (_cache[75] = [
                                            _createTextVNode(" $oss-help ")
                                          ])),
                                          _: 2
                                        }, 1040)
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[76] || (_cache[76] = _createElementVNode("span", null, " La balance âgée, afin d'être fiable, nécessite que les lettrages des comptes clients soyent terminés. ", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "5",
                              class: "ma-0 d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "auto",
                                      class: "ma-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "auto" }, {
                                                  default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                    _createElementVNode("h5", { class: "pl-4" }, "Solde N :", -1)
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "auto" }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.totalBalance411NL,
                                                            undefined,
                                                        )), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_col, {
                                      cols: "auto",
                                      class: "ma-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { cols: "auto" }, {
                                                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                    _createElementVNode("h5", { class: "pl-4" }, "Solde N+1 :", -1)
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_col, { cols: "auto" }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.totalBalance411NLNextPeriod,
                                                            undefined,
                                                        )), 1)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                            _ctx.generalLedgerExpand411
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                          "data-cy": "CheckReceivablesAgeing-grandLivre",
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.generalLedgerExpand411 = !_ctx.generalLedgerExpand411)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period, x) => {
                              return (_openBlock(), _createBlock(_component_v_card, {
                                key: x,
                                style: {"background-color":"white","border-radius":"25px","padding":"10px"},
                                class: "my-5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_subtitle, { class: "ma-0 pa-0" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", _hoisted_8, "Grand livre " + _toDisplayString(period.period), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(_component_v_col, { key: _ctx.refreshGeneralLedger411 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_GeneralLedger, {
                                                companyId: _ctx.companyId,
                                                accountingPeriodId: period.id,
                                                thirdPartyType: '411',
                                                inNm1: false,
                                                hideOptions: true,
                                                hideBodyAppend: true,
                                                withoutLetteringIfHidedOptions: true,
                                                onQueryDone: period.onQueryDone,
                                                enableAuditedAccountableAccounts: true
                                              }, null, 8, ["companyId", "accountingPeriodId", "onQueryDone"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.generalLedgerExpand411]
                        ])
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, _ctx.show411NL || _ctx.show411NLNextPeriod]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.showBarchart && _ctx.formattedBarChartData)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 4,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "pt-0 pl-0" }, {
                          default: _withCtx(() => _cache[80] || (_cache[80] = [
                            _createElementVNode("span", null, "Répartition des créances", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_bar_chart, {
                                  data: _ctx.formattedBarChartData,
                                  options: _ctx.barChartOptions,
                                  height: _ctx.$vuetify.display.mobile ? 200 : 300
                                }, null, 8, ["data", "options", "height"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.filteredThirdPartyCompanies.length)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 5,
                      class: "audit-card"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "d-flex align-center w-100 h-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "ma-0 py-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "d-flex align-center ma-0 pa-0" }, {
                                  default: _withCtx(() => [
                                    _cache[82] || (_cache[82] = _createElementVNode("h5", { class: "pl-4 ma-0" }, "Total créances T.T.C. calculées au :", -1)),
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_oss_date_picker_filled, {
                                      modelValue: _ctx.manualSelectedDate,
                                      "onUpdate:modelValue": [
                                        _cache[13] || (_cache[13] = ($event: any) => ((_ctx.manualSelectedDate) = $event)),
                                        _cache[14] || (_cache[14] = ($event: any) => {
                                        _ctx.expand = false;
                                        _ctx.expand4 = false;
                                    })
                                      ],
                                      textFieldReadOnly: false,
                                      returnDateStringFormat: 'YYYY-MM-DD',
                                      "hide-details": "",
                                      class: "px-6"
                                    }, null, 8, ["modelValue"]),
                                    _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                                      color: "secondary",
                                      class: "ml-2",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[81] || (_cache[81] = [
                                        _createTextVNode(" $oss-help ")
                                      ])),
                                      _: 1
                                    })), [
                                      [_directive_tooltip, 
                                        'Afin d\'évaluer les réels impayés et leur ancienneté, la date d\'évaluation des encours est modifiable'
                                    , "bottom"]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      class: "d-flex align-center px-4",
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "auto",
                                          class: "d-flex justify-start"
                                        }, {
                                          default: _withCtx(() => _cache[83] || (_cache[83] = [
                                            _createElementVNode("h5", { class: "pr-4" }, "T.T.C. :", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_col, {
                                          cols: "auto",
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("h5", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.globalAmounts.grossAmountSigned,
                                                    undefined,
                                                )), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "3" }),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.mode != 'Embedded')
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      "no-gutters": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "d-flex align-center pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.validated)
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 0,
                                                  color: "primary",
                                                  size: "large",
                                                  icon: "$check_circle"
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center pa-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                            _ctx.customersExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                              "data-cy": "CheckReceivablesAgeing-totalCreances",
                                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.customersExpand = !_ctx.customersExpand)),
                                              style: {"width":"40px"},
                                              class: "d-inline px-2"
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.manualSelectedDate != _ctx.accountingPeriodEnd)
                          ? (_openBlock(), _createElementBlock("h4", _hoisted_9, " Attention : les créances sont calculées à la date manuelle et pas à la fin de l'exercice. "))
                          : _createCommentVNode("", true),
                        _withDirectives(_createVNode(_component_v_card_text, {
                          transition: "expand",
                          class: "mt-0 pt-0"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.filteredThirdPartyCompanies.length)
                              ? (_openBlock(), _createBlock(_component_v_card, {
                                  key: 0,
                                  elevation: "0",
                                  style: {"background-color":"white","border-radius":"25px"},
                                  class: "py-0 mt-0"
                                }, {
                                  default: _withCtx(() => [
                                    (
                                    _ctx.globalAmounts.netAmountSigned || _ctx.globalAmounts.vatAmountSigned
                                )
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 0,
                                          "no-gutters": ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "3" }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                    _createElementVNode("h6", null, "dont détaillées (factures ou avoirs)", -1)
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      class: "d-flex align-center px-4",
                                                      "no-gutters": ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-start"
                                                        }, {
                                                          default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                            _createElementVNode("h6", { class: "pr-4" }, "T.T.C. :", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_spacer),
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-end"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("h6", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            -(
                                                                _ctx.globalAmounts.netAmountSigned +
                                                                _ctx.globalAmounts.vatAmountSigned
                                                            ),
                                                            undefined,
                                                        )), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      class: "d-flex align-center px-4",
                                                      "no-gutters": ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-start"
                                                        }, {
                                                          default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                            _createElementVNode("h6", null, "H.T. :", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_spacer),
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-end"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("h6", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(_ctx.globalAmounts.netAmountSigned),
                                                            undefined,
                                                        )), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      class: "d-flex align-center px-4",
                                                      "no-gutters": ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-start"
                                                        }, {
                                                          default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                            _createElementVNode("h6", null, "T.V.A. :", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_spacer),
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-end"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("h6", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(_ctx.globalAmounts.vatAmountSigned),
                                                            undefined,
                                                        )), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer)
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.globalAmounts.importFECAmountSignedTotal)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 1,
                                          "no-gutters": "",
                                          style: _normalizeStyle(_ctx.colorStyle(_ctx.globalAmounts.importFECAmountSignedTotal, 'red'))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "3" }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => _cache[88] || (_cache[88] = [
                                                    _createElementVNode("h6", null, "dont AN manuels (import FEC)", -1)
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "d-flex align-center ma-0 pa-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      class: "d-flex align-center px-4",
                                                      "no-gutters": ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-start"
                                                        }, {
                                                          default: _withCtx(() => _cache[89] || (_cache[89] = [
                                                            _createElementVNode("h6", { class: "pr-4" }, "T.T.C. :", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_spacer),
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-end"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("h6", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.globalAmounts.importFECAmountSignedTotal,
                                                            undefined,
                                                        )), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer)
                                          ]),
                                          _: 1
                                        }, 8, ["style"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.globalAmounts.bankTransactionsAmountSignedTotal)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 2,
                                          "no-gutters": "",
                                          style: _normalizeStyle(
                                    _ctx.colorStyle(
                                        _ctx.globalAmounts.bankTransactionsAmountSignedTotal,
                                        'red',
                                    )
                                )
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "3" }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => _cache[90] || (_cache[90] = [
                                                    _createElementVNode("h6", null, "dont écritures bancaires à lettrer", -1)
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      class: "d-flex align-center px-4",
                                                      "no-gutters": ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-start"
                                                        }, {
                                                          default: _withCtx(() => _cache[91] || (_cache[91] = [
                                                            _createElementVNode("h6", { class: "pr-4" }, "T.T.C. :", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_spacer),
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-end"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("h6", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.globalAmounts.bankTransactionsAmountSignedTotal,
                                                            undefined,
                                                        )), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer)
                                          ]),
                                          _: 1
                                        }, 8, ["style"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.globalAmounts.more411AlsAmountSignedTotal)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 3,
                                          "no-gutters": "",
                                          style: _normalizeStyle(
                                    _ctx.colorStyle(_ctx.globalAmounts.more411AlsAmountSignedTotal, 'red')
                                )
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "3" }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => _cache[92] || (_cache[92] = [
                                                    _createElementVNode("h6", null, "dont ODs multi clients", -1)
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, {
                                                      class: "d-flex align-center px-4",
                                                      "no-gutters": ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-start"
                                                        }, {
                                                          default: _withCtx(() => _cache[93] || (_cache[93] = [
                                                            _createElementVNode("h6", { class: "pr-4" }, "T.T.C. :", -1)
                                                          ])),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_v_spacer),
                                                        _createVNode(_component_v_col, {
                                                          cols: "auto",
                                                          class: "d-flex justify-end"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("h6", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.globalAmounts.more411AlsAmountSignedTotal,
                                                            undefined,
                                                        )), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_spacer)
                                          ]),
                                          _: 1
                                        }, 8, ["style"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_v_card_text, { class: "pa-0 mt-4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.doubtfullAccountsHeaders,
                                          items: _ctx.filteredThirdPartyCompanies,
                                          "sort-by": [
                                        { key: 'customer' },
                                        { key: 'netAmountSigned' },
                                        { key: 'grossAmountSigned' },
                                        { key: 'cumulatedCreditNotes' },
                                        { key: 'period31' },
                                        { key: 'period60' },
                                        { key: 'period90' },
                                        { key: 'period120' },
                                        { key: 'period180' },
                                        { key: 'period365' },
                                        { key: 'periodMore' },
                                    ],
                                          "sort-desc": [false, true],
                                          loading: _ctx.loading,
                                          class: "table",
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          "no-data": _withCtx(() => _cache[94] || (_cache[94] = [
                                            _createTextVNode("Aucune facture échue")
                                          ])),
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_10, _toDisplayString(props.item.customer.name), 1),
                                              (props.item.grossAmountSigned)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.grossAmountSigned,
                                                        { currency: "" },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      disabled: !props.item.ALs.length,
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodALs(
                                                            props.item.ALs,
                                                            ' : toutes périodes',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["disabled", "onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_12, " - ")),
                                              (
                                                    props.item.period31 &&
                                                    props.item.period31.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period31.grossAmountSigned,
                                                        { currency: "" },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      disabled: !props.item.period31.ALs.length,
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodALs(
                                                            props.item.period31.ALs,
                                                            ' - de 31 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["disabled", "onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_14, "-")),
                                              (
                                                    props.item.period60 &&
                                                    props.item.period60.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period60.grossAmountSigned,
                                                        { currency: "" },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      disabled: !props.item.period60.ALs.length,
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodALs(
                                                            props.item.period60.ALs,
                                                            ' - de 60 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["disabled", "onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_16, "-")),
                                              (
                                                    props.item.period90 &&
                                                    props.item.period90.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period90.grossAmountSigned,
                                                        { currency: "" },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      disabled: !props.item.period90.ALs.length,
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodALs(
                                                            props.item.period90.ALs,
                                                            ' - de 90 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["disabled", "onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_18, "-")),
                                              (
                                                    props.item.period120 &&
                                                    props.item.period120.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period120.grossAmountSigned,
                                                        { currency: "" },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      disabled: !props.item.period120.ALs.length,
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodALs(
                                                            props.item.period120.ALs,
                                                            ' - de 120 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["disabled", "onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_20, "-")),
                                              (
                                                    props.item.period180 &&
                                                    props.item.period180.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period180.grossAmountSigned,
                                                        { currency: "" },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      disabled: !props.item.period180.ALs.length,
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodALs(
                                                            props.item.period180.ALs,
                                                            ' - de 180 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["disabled", "onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_22, "-")),
                                              (
                                                    props.item.period365 &&
                                                    props.item.period365.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.period365.grossAmountSigned,
                                                        { currency: "" },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      disabled: !props.item.period365.ALs.length,
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodALs(
                                                            props.item.period365.ALs,
                                                            ' - de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["disabled", "onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_24, "-")),
                                              (
                                                    props.item.periodMore &&
                                                    props.item.periodMore.grossAmountSigned
                                                )
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                                                    _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.periodMore.grossAmountSigned,
                                                        { currency: "" },
                                                    )) + " ", 1),
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$remove_red_eye",
                                                      disabled: !props.item.periodMore.ALs.length,
                                                      onClick: ($event: any) => (
                                                        _ctx.openPeriodALs(
                                                            props.item.periodMore.ALs,
                                                            ' + de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    ),
                                                      size: "x-small",
                                                      color: "primary"
                                                    }, null, 8, ["disabled", "onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_26, " - "))
                                            ])
                                          ]),
                                          "body.append": _withCtx(() => [
                                            _createElementVNode("tr", _hoisted_27, [
                                              _cache[95] || (_cache[95] = _createElementVNode("th", null, "Totaux", -1)),
                                              _createElementVNode("th", _hoisted_28, [
                                                _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.sumsTable("grossAmountSigned"),
                                                            { currency: "" },
                                                        )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_30, [
                                                _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.sumsTable2(
                                                                "period31",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_32, [
                                                _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.sumsTable2(
                                                                "period60",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_34, [
                                                _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.sumsTable2(
                                                                "period90",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_36, [
                                                _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.sumsTable2(
                                                                "period120",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_38, [
                                                _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.sumsTable2(
                                                                "period180",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_40, [
                                                _createElementVNode("h3", _hoisted_41, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.sumsTable2(
                                                                "period365",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )), 1)
                                              ]),
                                              _createElementVNode("th", _hoisted_42, [
                                                _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.sumsTable2(
                                                                "periodMore",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )), 1)
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items", "loading"]),
                                        (_ctx.mode != 'Embedded')
                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                              key: 0,
                                              "no-gutters": ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_card_title, {
                                                      style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                                      class: "d-flex justify-end"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_spacer),
                                                        _createVNode(_component_v_btn, {
                                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                                          rounded: "",
                                                          class: "btn btn_blue",
                                                          onClick: _cache[16] || (_cache[16] = ($event: any) => {
                                                    _ctx.createAdjustmentsData();
                                                    _ctx.miscellanousOperationData = undefined;
                                                    _ctx.miscellaneousOperationDialog = true;
                                                }),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[96] || (_cache[96] = [
                                                            _createTextVNode(" OD ")
                                                          ])),
                                                          _: 1
                                                        }, 8, ["disabled"]),
                                                        _createVNode(_component_v_btn, {
                                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                                          rounded: "",
                                                          class: "btn btn_blue ml-2",
                                                          onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[97] || (_cache[97] = [
                                                            _createTextVNode(" Enregistrer ")
                                                          ])),
                                                          _: 1
                                                        }, 8, ["disabled"]),
                                                        (_ctx.closedPeriod)
                                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 0,
                                                              rounded: "",
                                                              class: "btn btn_blue ml-2",
                                                              disabled: "",
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[98] || (_cache[98] = [
                                                                _createTextVNode(" Valider ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                          : _createCommentVNode("", true),
                                                        _createVNode(_component_v_btn, {
                                                          rounded: "",
                                                          class: "btn btn_blue ml-2",
                                                          onClick: _cache[18] || (_cache[18] = ($event: any) => {
                                                    _ctx.validated = !_ctx.validated;
                                                    _ctx.adjustmentsExpand = false;
                                                    _ctx.createAdjustmentsData(
                                                        !_ctx.validated ? 'VALIDATE' : 'UPDATE',
                                                    );
                                                }),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(!_ctx.validated ? "Valider" : "Invalider"), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.customersExpand || _ctx.mode === 'Embedded']
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.periodDocuments.length > 0)
                  ? _withDirectives((_openBlock(), _createBlock(_component_v_card, {
                      key: 6,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expand_transition, null, {
                          default: _withCtx(() => [
                            (_ctx.periodDocuments.length > 0)
                              ? _withDirectives((_openBlock(), _createBlock(_component_v_card_text, {
                                  key: 0,
                                  class: "pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "px-5 pt-3" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("h3", null, _toDisplayString(_ctx.periodsCustomer.name) + " - Factures échues depuis " + _toDisplayString(_ctx.selectedPeriod), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_card_text, { class: "py-4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          headers: _ctx.periodDocumentsHeaders,
                                          items: _ctx.periodDocuments,
                                          "sort-by": [
                                        { key: 'date' },
                                        { key: 'netAmountSigned' },
                                        { key: 'grossAmountSigned' },
                                        { key: 'dueDate' },
                                        { key: 'name' },
                                    ],
                                          loading: _ctx.loading,
                                          class: "table",
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          "no-data": _withCtx(() => _cache[99] || (_cache[99] = [
                                            _createTextVNode("Aucune facture échue sur la période")
                                          ])),
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (props.item.docType)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(_ctx.$t("accountingItem.type." + props.item.docType)), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_44, "-")),
                                              (props.item.date)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_46, "-")),
                                              _createElementVNode("td", _hoisted_47, _toDisplayString(props.item.wording || "-"), 1),
                                              _createElementVNode("td", _hoisted_48, _toDisplayString(props.item.invoiceNumber || "-"), 1),
                                              _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.doc7and6 || 0,
                                                        { currency: "" },
                                                    )), 1),
                                              _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.doc445 || 0,
                                                        { currency: "" },
                                                    )), 1),
                                              _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        props.item.amountSigned || 0,
                                                        { currency: "" },
                                                    )), 1),
                                              (props.item.dueDate)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_52, _toDisplayString(_ctx.formatDate(props.item.dueDate)), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_53, "-")),
                                              _createElementVNode("td", _hoisted_54, [
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: "$remove_red_eye",
                                                  onClick: ($event: any) => (
                                                        _ctx.openObject(props.item.id, props.item.type)
                                                    ),
                                                  color: "primary"
                                                }, null, 8, ["onClick"])
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items", "loading"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 512)), [
                                  [_vShow, _ctx.expand]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_vShow, _ctx.expand]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.mode != 'Embedded')
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                      key: 7,
                      connectedDocuments: _ctx.connectedDocuments,
                      companyId: _ctx.companyId,
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      onUnlinkedDocument: _cache[19] || (_cache[19] = ($event: any) => (_ctx.unlinkDocument($event))),
                      onShowLinkedDocument: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showLinkedDocument($event)))
                    }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading && _ctx.mode != 'Embedded')
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                      key: 8,
                      results: _ctx.results,
                      companyId: _ctx.companyId
                    }, null, 8, ["results", "companyId"]))
                  : _createCommentVNode("", true),
                (_ctx.mode != 'Embedded')
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 9,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "5",
                              class: "ma-auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => _cache[100] || (_cache[100] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                            _ctx.commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                          "data-cy": "CheckReceivablesAgeing-commantairesDetailles",
                                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.commentExpand = !_ctx.commentExpand)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.commentExpand)
                          ? (_openBlock(), _createBlock(_component_v_card_text, {
                              key: 0,
                              transition: "expand"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "pt-6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_textarea, {
                                              modelValue: _ctx.comment,
                                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.comment) = $event)),
                                              disabled: _ctx.closedPeriod || _ctx.validated,
                                              "auto-grow": "",
                                              style: {"border":"1px #ededed solid"},
                                              outlined: ""
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, {
                                          style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            (_ctx.closedPeriod || _ctx.validated)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  rounded: "",
                                                  disabled: "",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[101] || (_cache[101] = [
                                                    _createTextVNode(" OD ")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 1,
                                                  rounded: "",
                                                  class: "btn btn_blue",
                                                  onClick: _cache[23] || (_cache[23] = ($event: any) => {
                                            _ctx.createAdjustmentsData();
                                            _ctx.miscellanousOperationData = undefined;
                                            _ctx.miscellaneousOperationDialog = true;
                                        }),
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                    _createTextVNode(" OD ")
                                                  ])),
                                                  _: 1
                                                })),
                                            (_ctx.closedPeriod || _ctx.validated)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 2,
                                                  disabled: "",
                                                  rounded: "",
                                                  class: "btn btn_blue ml-2",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                    _createTextVNode(" Enregistrer ")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 3,
                                                  rounded: "",
                                                  class: "btn btn_blue ml-2",
                                                  onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[104] || (_cache[104] = [
                                                    _createTextVNode(" Enregistrer ")
                                                  ])),
                                                  _: 1
                                                })),
                                            (_ctx.closedPeriod)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 4,
                                                  rounded: "",
                                                  class: "btn btn_blue ml-2",
                                                  disabled: "",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[105] || (_cache[105] = [
                                                    _createTextVNode(" Valider ")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (!_ctx.validated)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 5,
                                                    rounded: "",
                                                    class: "btn btn_blue ml-2",
                                                    onClick: _cache[25] || (_cache[25] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.adjustmentsExpand = false;
                                            _ctx.createAdjustmentsData('VALIDATE');
                                        }),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[106] || (_cache[106] = [
                                                      _createTextVNode(" Valider ")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 6,
                                                    rounded: "",
                                                    class: "btn btn_blue ml-2",
                                                    onClick: _cache[26] || (_cache[26] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.createAdjustmentsData('UPDATE');
                                        }),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[107] || (_cache[107] = [
                                                      _createTextVNode(" Invalider ")
                                                    ])),
                                                    _: 1
                                                  }))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.mode != 'Embedded')
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 10,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "pa-6 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "5",
                              class: "ma-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                  default: _withCtx(() => _cache[108] || (_cache[108] = [
                                    _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center px-0 justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center pa-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                            _ctx.shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                          "data-cy": "CheckReceivablesAgeing-commentairesSynthetiques",
                                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                                          style: {"width":"40px"},
                                          class: "d-inline px-2"
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.shortCommentExpand)
                          ? (_openBlock(), _createBlock(_component_v_card_text, {
                              key: 0,
                              transition: "expand"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "pt-6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {"padding-top":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_textarea, {
                                              modelValue: _ctx.shortComment,
                                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.shortComment) = $event)),
                                              disabled: _ctx.closedPeriod || _ctx.validated,
                                              "auto-grow": "",
                                              style: {"border":"1px #ededed solid"},
                                              outlined: ""
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_card_title, {
                                          style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_spacer),
                                            (_ctx.closedPeriod || _ctx.validated)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 0,
                                                  rounded: "",
                                                  disabled: "",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[109] || (_cache[109] = [
                                                    _createTextVNode(" OD ")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 1,
                                                  rounded: "",
                                                  class: "btn btn_blue",
                                                  onClick: _cache[29] || (_cache[29] = ($event: any) => {
                                            _ctx.createAdjustmentsData();
                                            _ctx.miscellanousOperationData = undefined;
                                            _ctx.miscellaneousOperationDialog = true;
                                        }),
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[110] || (_cache[110] = [
                                                    _createTextVNode(" OD ")
                                                  ])),
                                                  _: 1
                                                })),
                                            (_ctx.closedPeriod || _ctx.validated)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 2,
                                                  disabled: "",
                                                  rounded: "",
                                                  class: "btn btn_blue ml-2",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[111] || (_cache[111] = [
                                                    _createTextVNode(" Enregistrer ")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 3,
                                                  rounded: "",
                                                  class: "btn btn_blue ml-2",
                                                  onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.createAdjustmentsData()), ["stop"])),
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[112] || (_cache[112] = [
                                                    _createTextVNode(" Enregistrer ")
                                                  ])),
                                                  _: 1
                                                })),
                                            (_ctx.closedPeriod)
                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                  key: 4,
                                                  rounded: "",
                                                  class: "btn btn_blue ml-2",
                                                  disabled: "",
                                                  size: "small"
                                                }, {
                                                  default: _withCtx(() => _cache[113] || (_cache[113] = [
                                                    _createTextVNode(" Valider ")
                                                  ])),
                                                  _: 1
                                                }))
                                              : (!_ctx.validated)
                                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 5,
                                                    rounded: "",
                                                    class: "btn btn_blue ml-2",
                                                    onClick: _cache[31] || (_cache[31] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.adjustmentsExpand = false;
                                            _ctx.createAdjustmentsData('VALIDATE');
                                        }),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[114] || (_cache[114] = [
                                                      _createTextVNode(" Valider ")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_btn, {
                                                    key: 6,
                                                    rounded: "",
                                                    class: "btn btn_blue ml-2",
                                                    onClick: _cache[32] || (_cache[32] = ($event: any) => {
                                            _ctx.validated = !_ctx.validated;
                                            _ctx.createAdjustmentsData('UPDATE');
                                        }),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[115] || (_cache[115] = [
                                                      _createTextVNode(" Invalider ")
                                                    ])),
                                                    _: 1
                                                  }))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.displayActivityDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 11,
                      modelValue: _ctx.displayActivityDialog,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                      title: "Activité",
                      "valid-title": "Fermer",
                      onValid: _cache[34] || (_cache[34] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UsersActivitiesHistory, {
                          auditCheckKey: _ctx.acKey,
                          accountingPeriodId: _ctx.accountingPeriodId
                        }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_oss_dialog, {
                  modelValue: _ctx.miscellaneousOperationDialog,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
                  actions: _ctx.actionsMiscellaneousOperation,
                  "min-width": "90vw"
                }, {
                  default: _withCtx(() => [
                    (_ctx.miscellaneousOperationDialog)
                      ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                          key: 0,
                          companyId: _ctx.companyId,
                          prefilledRows: _ctx.miscellanousOperationData,
                          acKey: _ctx.acKey,
                          auditCheckResult: _ctx.auditCheckResult,
                          accountingPeriodId: _ctx.accountingPeriodId,
                          onUpsertedAuditCheckResult: _cache[36] || (_cache[36] = ($event: any) => (_ctx.refresh())),
                          actions: _ctx.actionsMiscellaneousOperation
                        }, null, 8, ["companyId", "prefilledRows", "acKey", "auditCheckResult", "accountingPeriodId", "actions"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue", "actions"]),
                (_ctx.openChat)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 12,
                      auditCheckAccountingPeriodKey: _ctx.chatId,
                      chatTitle: 'Chat'
                    }, null, 8, ["auditCheckAccountingPeriodKey"]))
                  : _createCommentVNode("", true),
                (_ctx.dialogAuditCheckDocumentsManager)
                  ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                      key: 13,
                      modelValue: _ctx.dialogAuditCheckDocumentsManager,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                      disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                      companyId: _ctx.companyId,
                      documentToDisplay: _ctx.documentToDisplay,
                      connectedDocuments: _ctx.connectedDocuments || [],
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                      onUpsertedAuditCheckResult: _ctx.upsertedACR,
                      onResetDialogData: _cache[39] || (_cache[39] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                    }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                  : _createCommentVNode("", true)
              ], 64)),
        (_ctx.deleteAuditCheckResultDialog)
          ? (_openBlock(), _createBlock(_component_AuditDeleteAuditCheckResultDialog, {
              key: 3,
              modelValue: _ctx.deleteAuditCheckResultDialog,
              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.deleteAuditCheckResultDialog) = $event)),
              auditCheckResultId: _ctx.auditCheckResultId,
              onClosed: _cache[41] || (_cache[41] = ($event: any) => {
                        _ctx.deleteAuditCheckResultLoading = false;
                        _ctx.deleteAuditCheckResultDialog = false;
                    }),
              onDeletedAcr: _ctx.deleteAcrDone
            }, null, 8, ["modelValue", "auditCheckResultId", "onDeletedAcr"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}